"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _1 = require("./_");
function accessor(data, field) {
    var value = data;
    if (typeof field === 'function')
        value = field(data);
    else if (data == null)
        value = data;
    else if (typeof field === 'string' && typeof data === 'object' && field in data)
        value = data[field];
    return value;
}
function dataValue(item, valueField) {
    return valueField && item && _1.has(item, valueField)
        ? item[valueField]
        : item;
}
exports.dataValue = dataValue;
function dataText(item, textField) {
    var value = accessor(item, textField);
    return value; // == null ? '' : (value + '')
}
exports.dataText = dataText;
function dataIndexOf(data, item, valueField) {
    var idx = -1, len = data.length, isValueEqual = function (datum) { return valueMatcher(item, datum, valueField); };
    while (++idx < len) {
        var datum = data[idx];
        if (datum === item || isValueEqual(datum)) {
            return idx;
        }
    }
    return -1;
}
exports.dataIndexOf = dataIndexOf;
/**
 * I don't know that the shallow equal makes sense here but am too afraid to
 * remove it.
 */
function valueMatcher(a, b, valueField) {
    return _1.isShallowEqual(dataValue(a, valueField), dataValue(b, valueField));
}
exports.valueMatcher = valueMatcher;
function dataItem(data, item, valueField) {
    var idx = dataIndexOf(data, dataValue(item, valueField), valueField);
    if (idx !== -1)
        return data[idx];
    return item;
}
exports.dataItem = dataItem;



//////////////////
// WEBPACK FOOTER
// ./node_modules/adp-react-components/lib/util/data-helpers.js
// module id = 61
// module chunks = 0 1 2 3 4 5 6